export default __webpack_public_path__ + "static/media/lipids.77c7ae3b.svg";